// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2r60x","buttons":"RemoveExpirationActionButtons_buttons__13er6"};